import { Box, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * スタイル付きToolbarコンポーネント - モバイルファースト対応
 */
export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: '100vw',
  padding: `0 ${theme.spacing(2)}`,
  minHeight: '56px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  transition: theme.transitions.create(['padding', 'min-height'], {
    duration: theme.transitions.duration.standard,
  }),

  [theme.breakpoints.up('sm')]: {
    padding: `0 ${theme.spacing(3)}`,
  },

  [theme.breakpoints.up('md')]: {
    padding: `0 ${theme.spacing(4)}`,
    minHeight: '64px',
  },

  [theme.breakpoints.up('lg')]: {
    padding: `0 ${theme.spacing(6)}`,
  },
}));

/**
 * 左側セクションのスタイル - レスポンシブ対応
 */
export const LeftSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  flex: 1,
  overflow: 'visible',

  '& .nav-button': {
    minWidth: '44px',
    minHeight: '44px',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'transform'], {
      duration: theme.transitions.duration.short,
    }),

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },

    '&:active': {
      transform: 'scale(0.95)',
    },
  },

  '& .logo': {
    fontSize: '1.2rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: theme.transitions.create(['color', 'text-shadow', 'text-decoration'], {
      duration: theme.transitions.duration.short,
    }),

    // Hover時の装飾は各要素側のsxで制御（ここでは何もしない）

    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
}));

/**
 * 右側セクションのスタイル - タッチフレンドリー
 */
export const RightSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexShrink: 0,
  minWidth: 'fit-content',
  position: 'relative', // フォーカスモードインジケーターの絶対位置指定のため

  '& .nav-button': {
    minWidth: '44px',
    minHeight: '44px',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'transform'], {
      duration: theme.transitions.duration.short,
    }),

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },

    '&:active': {
      transform: 'scale(0.95)',
    },
  },

  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.5),
  },
}));
